/*
 * @Author: Teemo Ding
 * @Date: 2021-08-06 14:27:52
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-25 14:11:02
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDatabaseSettings/config.tsx
 */

import { Input } from '@/src/components/Antd';
import { modal } from '@/src/utils/Modal';
import { Form } from 'antd';
import React from 'react';

import { replaceI18nVariables } from '@/src/tools/tools';
import { nameDict } from '@/src/types/common/customerDb';
import Action from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import css from './css.module.less';

const inputOnBlur = (form, index, key) => {
  const gender = form.getFieldValue(key);
  const keys = gender.map((item, index) => [key, index, 'value']);
  form.validateFields(keys).then(() => {
    gender[index].open = false;
    form.setFieldsValue({ gender });
  });
};

const removeOptions = (remove, index, type, { getI18n }) => {
  modal.error({
    title: replaceI18nVariables(
      getI18n(
        `customerDatabaseSetting.customerDatabaseSettings_config.deleteOption`,
      ),
      nameDict[type],
    ),
    content: replaceI18nVariables(
      getI18n(
        `customerDatabaseSetting.customerDatabaseSettings_config.deleteOption_content`,
      ),
      nameDict[type],
    ),
    onOkText: getI18n('general.delete'),
    onOk: () => {
      remove(index);
    },
    onCancel: () => {
      return;
    },
  });
};
export const genderColumns = (fields, remove, form, disabled, { getI18n }) => [
  {
    title: getI18n('customerDatabaseSetting.gender.gender'),
    dataIndex: 'value',
    default: true,
    optional: true,
    key: 'value',
    className: css.columnClass,
    minWidth: 300,
    childGenerate: (text, record, index) => {
      return (
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.genders !== currentValues.genders
          }>
          {({ getFieldValue }) =>
            getFieldValue('genders')[index].open === true ? (
              <Form.Item
                className={css.tableFormItem}
                validateTrigger={[]}
                rules={[
                  {
                    required: true,
                    message: getI18n(
                      'customerDatabaseSetting.customerDatabaseSettings_config.required',
                    ),
                  },
                  {
                    validator: async () => {
                      const gender = form.getFieldValue('genders');
                      const genderList = gender.map((item) => item.value);
                      if (new Set(genderList).size !== genderList.length) {
                        return Promise.reject(new Error('Repetitive option'));
                      } else {
                        return Promise.resolve();
                      }
                    },
                  },
                ]}
                name={[fields[index].name, 'value']}>
                <Input
                  autoFocus
                  disabled={disabled}
                  onBlur={() => inputOnBlur(form, index, 'genders')}
                />
              </Form.Item>
            ) : (
              <div className={css.columnClassName}>
                {getFieldValue('genders')[index].value}
              </div>
            )
          }
        </Form.Item>
      );
    },
  },
  {
    title: getI18n('general.linkModule.Modal.action'),
    dataIndex: 'action',
    default: true,
    optional: true,
    key: 'action',
    className: css.columnClass,
    width: 256,
    childGenerate: (text, record, index) =>
      !form.getFieldValue('genders')[index].defaultField ? (
        <div className={css.actionDelete}>
          <Action
            disabled={disabled}
            onDelete={() => removeOptions(remove, index, 'Gender', { getI18n })}
          />
        </div>
      ) : null,
  },
];

export const customerTitleColumns = (
  fields,
  remove,
  form,
  disabled,
  { getI18n },
) => [
  {
    title: getI18n(
      'customerDatabaseSetting.customerDatabaseSettings_config.titleOptions',
    ),
    dataIndex: 'value',
    default: true,
    optional: true,
    key: 'value',
    className: css.columnClass,
    minWidth: 300,
    childGenerate: (text, record, index) => {
      return (
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.titles !== currentValues.titles
          }>
          {({ getFieldValue }) =>
            getFieldValue('titles')[index].open === true ? (
              <Form.Item
                className={css.tableFormItem}
                validateTrigger={[]}
                rules={[
                  {
                    required: true,
                    message: getI18n(
                      'customerDatabaseSetting.customerDatabaseSettings_config.required',
                    ),
                  },
                  {
                    validator: async () => {
                      const titles = form.getFieldValue('titles');
                      const titlesList = titles.map((item) => item.value);
                      if (new Set(titlesList).size !== titlesList.length) {
                        return Promise.reject(new Error('Repetitive option'));
                      } else {
                        return Promise.resolve();
                      }
                    },
                  },
                ]}
                name={[fields[index].name, 'value']}>
                <Input
                  autoFocus
                  disabled={disabled}
                  onBlur={() => inputOnBlur(form, index, 'titles')}
                />
              </Form.Item>
            ) : (
              <div>{getFieldValue('titles')[index].value}</div>
            )
          }
        </Form.Item>
      );
    },
  },
  {
    title: getI18n('general.linkModule.Modal.action'),
    dataIndex: 'action',
    default: true,
    optional: true,
    key: 'action',
    className: css.columnClass,
    width: 256,
    childGenerate: (text, record, index) =>
      !form.getFieldValue('titles')[index].defaultField ? (
        <Action
          onDelete={() => removeOptions(remove, index, 'Title', { getI18n })}
          disabled={disabled}
        />
      ) : null,
  },
];
export const AdvancedCustomerInformationColumn = (
  onDelete,
  onEdit,
  disabled,
  { getI18n },
) => [
  {
    title: getI18n(
      'customerDatabaseSetting.customerDatabaseSettings_config.customerInformationField',
    ),
    dataIndex: 'name',
    default: true,
    optional: true,
    key: 'name',
    className: css.columnClass,
    minWidth: 166,
  },
  {
    title: getI18n(
      'customerDatabaseSetting.customerDatabaseSettings_config.fieldType',
    ),
    dataIndex: 'type',
    default: true,
    optional: true,
    key: 'type',
    className: css.columnClass,
    minWidth: 192,
  },
  {
    title: getI18n(
      'customerDatabaseSetting.customerDatabaseSettings_config.options',
    ),
    dataIndex: 'selectorOptions',
    default: true,
    optional: true,
    key: 'selectorOptions',
    className: css.columnClass,
    minWidth: 448,
    render: (text, record, index) => {
      const values = (text || []).map((item) => item.value);
      return values.length ? values.join(',') : '-';
    },
  },
  {
    title: getI18n('general.linkModule.Modal.action'),
    dataIndex: 'action',
    default: true,
    optional: true,
    align: 'center',
    key: 'action',
    className: css.columnClass,
    minWidth: 192,
    render: (text, record, index) => (
      <Action
        disabled={disabled}
        onDelete={() => {
          onDelete(index, record);
        }}
        onEdit={() => {
          onEdit(record, index);
        }}
      />
    ),
  },
];

export const breadcrumbData = (name, uuid, { getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/customerDatabase',
    name: getI18n('customerList.customerDetail_config.customerDatabase'),
  },
  {
    url: '',
    name: name,
  },
  {
    url: '',
    name: getI18n(
      'customerDatabaseSetting.customerDatabaseSettings_config.databaseSettings',
    ),
  },
];
